module.exports = fox._r("images/promo/chain.png", __webpack_public_path__ + "_/_/_/common/frame/images/promo/chain.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/promo/chain.png
// module id = 398
// module chunks = 2